if (!customElements.get('ts-matching-look')) {
  customElements.define('ts-matching-look', class extends HTMLElement {
    connectedCallback() {
      this.data = JSON.parse(this.querySelector('[data-match-data]').textContent);
      this.output = this.querySelector('[data-match-output]');
      this.status = this.querySelector('[data-match-status]');
      this.onChange = () => requestAnimationFrame(() => this.render());
      this.scope = this.closest('.shopify-section') || document;
      this.scope.addEventListener('change', this.onChange);
      this.render();
    }
    disconnectedCallback() {
      this.scope?.removeEventListener('change', this.onChange);
    }
    element(tag, text, className) {
      const el = document.createElement(tag);
      if (text) el.textContent = text;
      if (className) el.className = className;
      return el;
    }
    money(cents) {
      return new Intl.NumberFormat(this.data.locale, {style:'currency', currency:this.data.currency}).format(cents / 100);
    }
    selected() {
      const current = this.data.catalog.find(p => p.id === this.data.current);
      if (!current) return null;
      const picker = this.scope.querySelector('variant-radios, variant-selects');
      let pattern = picker?.querySelector('input:checked')?.value || picker?.querySelector('select')?.value;
      const form = document.getElementById(this.dataset.form);
      const variantId = form?.querySelector('[name="id"]')?.value;
      return {product:current, variant:current.variants.find(v=>v.title===pattern) || current.variants.find(v=>v.id===variantId) || current.variants[0]};
    }
    picture(product, variant) {
      const link = this.element('a');
      link.href = product.url + '?variant=' + variant.id;
      link.setAttribute('aria-label', product.title + ' · ' + variant.title);
      const img = this.element('img');
      img.src = variant.image;
      img.alt = product.title + ' · ' + variant.title;
      img.width = 240;
      img.height = 240;
      img.loading = 'lazy';
      link.append(img);
      return link;
    }
    button(text, entries) {
      const button = this.element('button', text, 'ts-match__button');
      button.type = 'button';
      button.disabled = entries.some(e=>!e.variant.available);
      if (button.disabled) button.textContent = this.data.text.unavailable;
      button.addEventListener('click',()=>this.add(entries));
      return button;
    }
    async add(entries) {
      if (this.busy) return;
      this.busy = true;
      this.querySelectorAll('button').forEach(b=>b.disabled=true);
      this.status.textContent = this.data.text.adding;
      try {
        const items = entries.map(e=>({id:e.variant.id,quantity:1,properties:{'Matching look':e.variant.title,...(e.product.preorder?{'Pre-order':this.data.text.shipping}:{})}}));
        const response = await fetch(this.data.root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(typeof result.description==='string'?result.description:this.data.text.error);
        window.location.assign(this.data.root+'cart');
      } catch (error) {
        this.status.textContent = error.message || this.data.text.error;
        this.busy = false;
        this.render();
      }
    }
    render() {
      if(this.busy) return;
      this.output.replaceChildren();
      const selected = this.selected();
      const pattern = this.dataset.pattern || selected?.variant.title;
      if(!pattern) return;
      const socks = this.data.catalog.find(p=>p.kind==='socks' && p.variants.some(v=>v.title===pattern));
      const sock = socks?.variants.find(v=>v.title===pattern);
      let caps = this.data.catalog.filter(p=>p.kind==='cap' && p.variants.some(v=>v.title===pattern));
      if(selected?.product.kind==='cap') caps = caps.filter(p=>p.id===selected.product.id);
      if(!sock || !caps.length) {this.hidden=true;return;}
      this.hidden=false;
      if(this.dataset.home==='true') {
        const heading = this.element('h3',pattern,'ts-match__pattern');
        this.output.append(heading);
        if(caps.length>1) {
          const label = this.element('label',this.data.text.capStyle,'ts-match__label');
          const select = this.element('select');
          select.setAttribute('aria-label',pattern+' · '+this.data.text.capStyle);
          caps.forEach(p=>{const option=this.element('option',p.title);option.value=p.id;select.append(option);});
          select.value=this.capId || caps[0].id;
          select.addEventListener('change',()=>{this.capId=select.value;this.render();});
          label.append(select);this.output.append(label);
          caps=caps.filter(p=>p.id===select.value);
        }
      }
      for(const cap of caps) {
        const cv=cap.variants.find(v=>v.title===pattern);
        const card=this.element('div',null,'ts-match__card');
        const images=this.element('div',null,'ts-match__images');
        images.append(this.picture(cap,cv),this.picture(socks,sock));card.append(images);
        const capLine=this.element('p',cap.title+' · '+this.money(cv.price));
        const sockLine=this.element('p',socks.title+' · '+this.money(sock.price));
        card.append(capLine,sockLine,this.element('p',pattern+' · '+this.data.text.oneEach,'ts-match__detail'));
        card.append(this.element('p',this.data.text.total+' '+this.money(cv.price+sock.price),'ts-match__total'));
        if(cap.preorder||socks.preorder) card.append(this.element('p',this.data.text.shipping,'ts-match__detail'));
        const pair=[{product:cap,variant:cv},{product:socks,variant:sock}];
        if(selected) {
          const match=selected.product.kind==='cap'?pair[1]:pair[0];
          card.append(this.button(selected.product.kind==='cap'?this.data.text.addSocks:this.data.text.addCap,[match]));
        }
        card.append(this.button(this.data.text.addBoth+' · '+this.money(cv.price+sock.price),pair));
        this.output.append(card);
      }
    }
  });
}
